import { usageStatistics } from '@vaadin/vaadin-usage-statistics/vaadin-usage-statistics.js';

// @ts-expect-error: Generated function
// eslint-disable-next-line @typescript-eslint/no-unsafe-call
__REGISTER__();

usageStatistics();
